import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Twitter } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function Footer() {
  return (
    <footer className="bg-[#061426] text-white/80" data-testid="site-footer">
      <div className="container-corp py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2 max-w-md">
            <img
              src="/vpcl-logo-light.png"
              alt="VPCL Infra Limited"
              className="h-14 w-auto object-contain mb-6"
              data-testid="footer-logo"
            />
            <p className="text-sm leading-relaxed text-white/60 mb-6">
              Large-scale renewable energy infrastructure & EPC company delivering
              utility-scale solar, PM-KUSUM, open access and government solar projects
              across India.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
                className="w-9 h-9 border border-white/20 flex items-center justify-center hover:border-[#16A34A] hover:text-[#16A34A] transition-colors"
              >
                <Linkedin size={16} />
              </a>
              <a
                href="#"
                aria-label="Twitter"
                data-testid="footer-twitter"
                className="w-9 h-9 border border-white/20 flex items-center justify-center hover:border-[#16A34A] hover:text-[#16A34A] transition-colors"
              >
                <Twitter size={16} />
              </a>
            </div>
          </div>

          {/* Sitemap */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.22em] text-[#16A34A] mb-5">
              Company
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors" data-testid="footer-link-about">About VPCL</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/projects" className="hover:text-white transition-colors" data-testid="footer-link-projects">Projects</Link></li>
              <li><Link to="/government-projects" className="hover:text-white transition-colors" data-testid="footer-link-government">Government</Link></li>
              <li><Link to="/landowner" className="hover:text-white transition-colors" data-testid="footer-link-landowner">Landowner Opportunities</Link></li>
              <li><Link to="/credibility" className="hover:text-white transition-colors" data-testid="footer-link-credibility">Credibility</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.22em] text-[#16A34A] mb-5">
              Corporate Office
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex gap-3">
                <MapPin size={16} className="text-[#16A34A] mt-0.5 flex-shrink-0" />
                <span className="text-white/70 leading-relaxed">
                  {COMPANY.address.line1},<br />
                  {COMPANY.address.line2},<br />
                  {COMPANY.address.city} {COMPANY.address.pin}
                </span>
              </li>
              <li className="flex gap-3 items-center">
                <Phone size={16} className="text-[#16A34A] flex-shrink-0" />
                <a href={`tel:${COMPANY.phone}`} className="hover:text-white transition-colors">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex gap-3 items-center">
                <Mail size={16} className="text-[#16A34A] flex-shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
          <div>
            © {new Date().getFullYear()} VPCL Infra Limited. All rights reserved.
          </div>
          <div className="flex gap-6">
            <span>CIN: <span className="font-mono">{COMPANY.cin}</span></span>
            <span>GST: <span className="font-mono">{COMPANY.gst}</span></span>
          </div>
        </div>
      </div>
    </footer>
  );
}
